import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import useCacheQuery, {CacheQueryOpts, CacheQueryOutput} from "../../core/services/query/hooks/useCacheQuery";
import HotelRoomRate from "../types/HotelRoomRate";

type Output = HotelRoomRate[];

export default function useHotelGetRoomRatesInfo (
    roomHotelEvent: number[]|undefined,
    startOn: string|undefined,
    endOn: string|undefined,
    options?: CacheQueryOpts
): CacheQueryOutput<Output> {
    const client = useAPIClient();
    return useCacheQuery<Output>(
        ["room-rates-by-room-ids", roomHotelEvent],
        () => {
            return client.get<any>(`room_rates`, {
                "roomHotelEvent": roomHotelEvent,
                "itemsPerPage": 1000,
                "date[after]": startOn,
                "date[strictly_before]": endOn,
                "order[date]": "asc",
            });
        },
        options
    );
}
